module.exports = __webpack_public_path__ + "static/img/321.1c5c01b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/321.jpg
// module id = AX5C
// module chunks = 0